module.exports = __webpack_public_path__ + "static/img/kripsol-nav.a5452be.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos/kripsol-nav.jpg
// module id = Rell
// module chunks = 4